import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {TextUtils} from "../../../../../shared/utils/text-utils";

@Component({
    selector: 'db-products-table',
    templateUrl: './products-table.component.html',
    styleUrls: ['./products-table.component.scss'],
    standalone: false
})
export class ProductsTableComponent implements OnInit {
  isMobile = false;
  public heads: string[] = [
    TextUtils.getText('text_image'),
    TextUtils.getText('text_product'),
    TextUtils.getText('text_inventory'),
    TextUtils.getText('text_category'),
    TextUtils.getText('text_price'),
    TextUtils.getText('text_status')
  ];
  @Output() reorder: EventEmitter<void> = new EventEmitter<void>();
  constructor() {
  }

  ngOnInit() {
  }

}
